export const porkSkewers = {
  id: "porkSkewers",
  link: "/#/recipes/recipes/porkSkewers",
  name: "Pork Skewers",
  cuisine: "Alethi Men's Food",
  summary: "Grilled pork and vegetable chunks, served with dipping sauces",
  inspiration: "Shorlog",
  quantity: "10 skewers",
  time: "45 minutes, plus 1-24 hours of marinating",
  notes:
    "This was served at Roshone's manor, who we know clung to old Alethi ways, even when no longer popular. (The Way of Kings ch 25) To try and show that in the meal, I looked to Mongolian dishes and found Shorlog. Shorlog is basically barbecue - meat cooked on skewers over a fire. The legend goes that Mongolian warriors would cook their meat on their shields or with their swords. I could see a similar tradition for the Alethi - semi-nomadic warriors, eating meat on the go. I included vegetables as well since they were mentioned in the text.",
  quotes:
    "...the spicy scents made Kal’s stomach rumble. How long had it been since he’d had pork? There were five different dipping sauces on the table... “Very well,” Roshone said, taking a piece of flatbread from the basket and wrapping it around his skewer, pulling off several vegetable chunks at once and eating them with the bread. (The Way of Kings ch 37)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/pork-skewers-overview.jpg",
  ingredientSections: [
    {
      title: "Skewers",
      ingredients: [
        {
          item: "garlicClove",
          display: "6 cloves garlic"
        },
        {
          item: "ginger",
          display: "2 inches ginger"
        },
        {
          item: "gochugaru",
          display: "1/3 cup gochugaru"
        },
        {
          item: "coconut",
          display: "2 tbsp coconut oil"
        },
        {
          item: "turmeric",
          display: "1/2 tsp ground turmeric"
        },
        {
          item: "coriander",
          display: "1/2 tsp ground coriander"
        },
        {
          item: "cumin",
          display: "1 tsp ground cumin"
        },
        {
          item: "garamMasala",
          display: "1 tsp garam masala"
        },
        {
          item: "salt",
          display: "1 tsp salt"
        },
        {
          item: "lemon",
          display: "2 tbsp lemon juice"
        },
        {
          item: "onion",
          display: "3 onions"
        },
        {
          item: "yogurt",
          display: "1/2 cup plain yogurt"
        },
        {
          item: "water",
          display: "1/2 cup water"
        },
        {
          item: "pork",
          display: "4 lbs pork loin"
        },
        {
          item: "bellPepper",
          display: "3 orange or red bell peppers"
        },
        {
          item: "summerSquash",
          display: "2 yellow squash"
        },
        {
          item: "flatbread",
          display:
            "flatbread, such as 1 recipe Tallew Flatbread or corn tortillas"
        }
      ]
    },
    {
      title: "Savory sauce",
      ingredients: [
        {
          item: "oysterSauce",
          display: "2 tbsp oyster sauce"
        },
        {
          item: "vinegar",
          display: "1 tbsp rice vinegar (unseasoned)"
        },
        {
          item: "garlicClove",
          display: "1 clove garlic, minced"
        },
        {
          item: "gochugaru",
          display: "1/2 tbsp gochugaru"
        },
        {
          item: "water",
          display: "1 tbsp water"
        }
      ]
    },
    {
      title: "Sour sauce",
      ingredients: [
        {
          item: "yogurt",
          display: "1/4 cup plain yogurt"
        },
        {
          item: "vinegar",
          display: "2 tsp rice vinegar"
        },
        {
          item: "garamMasala",
          display: "1/2 tsp garam masala"
        }
      ]
    },
    {
      title: "Oil sauce",
      ingredients: [
        {
          item: "coconut",
          display: "2 tbsp coconut oil"
        },
        {
          item: "vinegar",
          display: "2 tbsp rice vinegar"
        },
        {
          item: "mustard",
          display: "1/4 tsp ground mustard seed"
        }
      ]
    },
    {
      title: "Spicy sauce",
      ingredients: [
        {
          item: "onion",
          display: "1/4 onion"
        },
        {
          item: "coconut",
          display: "1 tbsp coconut oil"
        },
        {
          item: "garlicClove",
          display: "1 clove garlic, minced"
        },
        {
          item: "ginger",
          display: "1/2 inch ginger"
        },
        {
          item: "curryPaste",
          display: "2 tsp yellow curry paste"
        },
        {
          item: "salt",
          display: "1/8 tsp salt"
        },
        {
          item: "coconut",
          display: "1/4 cup coconut milk"
        },
        {
          item: "water",
          display: "1/4 cup water"
        },
        {
          item: "gochugaru",
          display: "1 tbsp gochugaru"
        }
      ]
    },
    {
      title: "Fruit sauce",
      ingredients: [
        {
          item: "plum",
          display: "1 plum"
        },
        {
          item: "ginger",
          display: "1/2 inch ginger"
        },
        {
          item: "lemon",
          display: "1 tbsp lemon juice"
        },
        {
          item: "water",
          display: "1/4 cup water"
        },
        {
          item: "cloves",
          display: "1/4 tsp ground cloves"
        }
      ]
    }
  ],
  steps: [
    "Prepare the marinade. Add 6 cloves garlic, 2 inches peeled ginger, 1 onion, 1/4 cup gochugaru, 2 tbsp coconut oil, 1/2 tsp turmeric, 1/2 tsp coriander, 1 tsp cumin, 1 tsp garam masala, 1 tsp salt, 2 tbsp lemon juice, 1/2 cup yogurt, and 1/2 cup water to a food processor. Process to a somewhat chunky liquid.",
    "Chop the pork loin into large 2 inch cubes, removing the worst of the fat. Add the pork and the marinade to a ziploc bag, remove as much air as possible, then seal and let sit in the refrigerator for 1 to 24 hours.",
    "1 to 2 hours before cooking the pork, prepare the vegetables. Cut 2 onions and 3 bell peppers in 2 inch chunks, and slice 2 yellow squash into 1/2 inch slices. Add them to the marinade along with the pork. Reseal and let sit in the refrigerator 1 to 2 hours.",
    "Skewer the meat and the vegetables on separate skewers. I prefer metal skewers, but wood/bamboo works as well. If using wood or bamboo, soak the skewers in water for 15 minutes first. Space the chunks such that they're not quite touching.",
    "Place all skewers on the grill, and grill at about 375 degrees Fahrenheit for 10 minutes, turning once, or until vegetables are tender and start to blacken on the edges. Remove the vegetable skewers and keep warm. Continue to cook the pork skewers until a meat thermometer registers 145 degrees inside the pork.",
    "Meanwhile, prepare the sauces.",
    "Savory sauce: Whisk together all ingredients",
    "Sour sauce: Whisk together all ingredients",
    "Oil sauce: Melt the coconut oil over medium low heat. Whisk in the rice vinegar. Whisk in the mustard powder. This will help keep the sauce from separating - whisk again when it starts to separate.",
    "Spicy sauce: Dice the onion, and peel and mince the ginger and garlic. Heat the oil in a pan over medium high heat, then add the onion, garlic, and ginger, and cook until the onion is transparent but not browned, about 5 minutes. Add the curry paste and salt. Cook and stir until combined. Add the coconut milk, water, and gochugaru. Cook and stir an additional 2 minutes.",
    "Fruit sauce: Remove the pit from the plum. Finely chop the plum or process it in a food processor. Peel and mince the ginger. Add both to a saucepan along with the other ingredients. Simmer on medium, covered, stirring occasionally, until everything comes together and forms a sauce, about 10 minutes.",
    "Serve the vegetable and meat skewers with flatbread and dipping sauces"
  ]
}
